import React from 'react';
import { createRoot } from 'react-dom/client';
import PatternBoard from './PatternBoard';

// Separate webpack entry (js/dist/pattern-board-app.js) for /patterns/{theme}. Replaces the static
// board in #pattern-board with the interactive one, seeded from data-line and data-caption.
const el = document.getElementById('pattern-board');
const raw = el?.dataset.line?.trim();
if (el && raw) {
  const line = raw.split(/\s+/).filter((t) => t.length > 0 && !/^\d+\.+$/.test(t));
  if (line.length > 0) {
    const caption = el.dataset.caption?.trim() || undefined;
    el.innerHTML = '';
    createRoot(el).render(<PatternBoard line={line} caption={caption} />);
  }
}
